import { render, staticRenderFns } from "./ComboHandler.vue?vue&type=template&id=2fbd226e&scoped=true&"
import script from "./ComboHandler.vue?vue&type=script&lang=js&"
export * from "./ComboHandler.vue?vue&type=script&lang=js&"
import style0 from "./ComboHandler.vue?vue&type=style&index=0&id=2fbd226e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd226e",
  null
  
)

export default component.exports